<div class="not-found-container">
    <div class="not-found-content">
        <h1 class="error-code">404</h1>
        <h2 class="error-message">¡Ups! Página no encontrada</h2>
        <p class="error-description">Lo sentimos, la página que estás buscando no existe o ha sido movida.</p>
        <a routerLink="/" class="return-button">Volver al inicio</a>
    </div>
</div>